// 거시 이벤트방 활성 목록 훅 (시그니처 6엔진 Step 4 진입점 공용)
// 홈 시황 위젯·커뮤 마감임박 칩·금융 NavCard가 공유. 토글 OFF면 서버가 [] 반환 → 진입점 전부 숨김(design doc §7).
// GET /api/mobile/macro-event (id 없음) → list_active_macro_events RPC. 실패 시 조용히 [](진입점 미노출).
import { useState, useEffect } from 'react';
import { apiFetch } from '../lib/api';
import { pickPrimaryEvent, type MacroEventLite } from '@core/community/macroEventRules';

export { pickPrimaryEvent, type MacroEventLite };

export function useActiveMacroEvents(): MacroEventLite[] {
  const [events, setEvents] = useState<MacroEventLite[]>([]);
  useEffect(() => {
    let alive = true;
    apiFetch<{ ok: boolean; result: MacroEventLite[] }>('/api/mobile/macro-event')
      .then((res) => { if (alive) setEvents(Array.isArray(res?.result) ? res.result : []); })
      .catch(() => { /* 진입점은 best-effort — 실패 시 미노출 */ });
    return () => { alive = false; };
  }, []);
  return events;
}
